import { Col, SelectField } from '@/components';
import { COL_MIN_WIDTH } from '@/features/search/_utils/projects-search';
import {
  KsAggregationTargetTypeLabelModifier,
  ksAggregationTargetTypeEnum,
} from '@/utils/enum';
import { type FC, memo } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import type { KsAnalysisSearchFormType } from '../../_models/ks-analysis-search';

const options = ksAggregationTargetTypeEnum.options.map((value) => ({
  value,
  label: KsAggregationTargetTypeLabelModifier[value],
}));

export const KsAggregationTargetColField: FC = memo(() => {
  const { t } = useTranslation();

  const {
    control,
    formState: { errors },
  } = useFormContext<KsAnalysisSearchFormType>();

  return (
    <Col span={4} style={{ minWidth: COL_MIN_WIDTH.basic }}>
      <SelectField
        name="aggregationTargetType"
        label={t('aggregation-target')}
        control={control}
        options={options}
        allowClear={false}
        errors={errors}
      />
    </Col>
  );
});
